import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import Radio from '@/common/components/Radio'
import { cn } from '@/common/utils/cn'
import { formatPercentage } from '@/common/utils/formatters'
import { IntegrationCodeMatch } from '@/features/modelIntegrationCodes/types/suggestedModel.type'
import { getSimilarityColor } from '@/features/modelIntegrationCodes/utils/getSimilarityColor'
import { ImageOffIcon } from 'lucide-react'

interface ModelOptionProps {
  model: IntegrationCodeMatch
  isSelected: boolean
  onSelect: () => void
}

const ModelOption = ({ model, isSelected, onSelect }: ModelOptionProps) => {
  const colorClass = getSimilarityColor(model.score)
  const label = model.name?.trim() || model.integration_code_value

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'w-full flex items-center gap-2 p-4 rounded-lg text-left transition-colors',
        isSelected ? 'bg-blue-100' : 'bg-white-100 hover:bg-white-200',
      )}
      data-testid={`model_option_${model.provider}_${model.integration_code_value}`}
    >
      <Radio
        checked={isSelected}
        onChange={onSelect}
        name={`model_${model.provider}_${model.integration_code_value}`}
      />

      <ImageWithPlaceholder
        className="h-10 w-auto aspect-video rounded-sm bg-white-400"
        url={model.image_url}
        placeholderIcon={ImageOffIcon}
        iconClassName="size-6"
        placeholderIconProps={{ strokeWidth: 2 }}
      />

      <p className="flex-1 min-w-0 text-base font-bold">{label}</p>

      <div className="flex flex-col items-end justify-center shrink-0">
        <p className={cn('text-[10px] italic font-light leading-3', colorClass)}>Semelhança</p>
        <p className={cn('text-xs font-bold leading-3', colorClass)}>
          {!!model.score && model.score >= 0 ? formatPercentage(model.score) : '--'}
        </p>
      </div>
    </button>
  )
}

export default ModelOption
